import qs from 'query-string';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { PATH } from 'src/constants/Path';
import { RootState } from 'src/redux/reducers/rootReducer';

export const useRoute = () => {
  const auth = useSelector((state: RootState) => state.auth);

  const isUserLoggedOut = !auth || !auth.token;
  const isUserLoggedIn = auth && auth.token && auth.user && auth.user.roles;

  const location = useLocation();
  const { redirect_link } = qs.parse(location.search);
  const [searchParams] = useSearchParams();

  const isLoading = useSelector(
    (state: RootState) => state.main.loadingPaymentInfo,
  );

  const isRedirect =
    ((!auth.isSessionExpired && location.pathname == PATH.home) ||
      (isUserLoggedIn && location.pathname == PATH.PUBLIC.login)) &&
    !!redirect_link;

  const currentPath = location.pathname || '';

  const pathname =
    currentPath.length > 1 ? currentPath.replace(/\/+$/, '') : currentPath;

  const redirectUrl = () => {
    if (
      location.pathname !== PATH.PUBLIC.login &&
      location.pathname !== PATH.root &&
      location.pathname !== PATH.home
    ) {
      if (searchParams.get('redirect_link')) {
        searchParams.delete('redirect_link');
      }

      return `${PATH.PUBLIC.login}?redirect_link=${
        location.pathname
      }?${searchParams.toString()}`;
    }
    if (isRedirect) {
      return (redirect_link as string) || PATH.root;
    }
    if (isUserLoggedOut) return PATH.PUBLIC.login;
    return PATH.root;
  };

  const state = {
    isLoading,
    isRedirect,
    isUserLoggedIn,
    isUserLoggedOut,
    pathname,
  };
  return { state, redirectUrl };
};
